<template>
  <div :class="{ 'w header': true, ...extraHeaderClass }">
    <!-- LOGO -->
    <div
      class="header-logo"
      @click="logo"
    >
      <img
        src="~@/assets/imgs/logo/newA_logo_v2_h5.png"
        alt=""
        class="black-logo"
      />
    </div>
    <!-- 右侧 -->
    <div class="header-right">
      <div class="navIcon">
        <loading-icon />
        <ViewListIcon
          v-if="!visible"
          size="32"
          @click="onIcon()"
        />
        <img
          v-if="visible"
          src="~@/assets/imgs/close.png"
          class="nav_icon"
          @click="onIcon()"
        />
      </div>
    </div>
    <div
      v-if="visible"
      class="modal-show"
    >
      <div class="mobile-nav">
        <div
          v-for="(item, idx) in menuList"
          :key="idx"
        >
          <div
            :class="
              item.fullPath === curMenu ||
              (item.hasChild && item.menu.findIndex((it) => it.fullPath === curMenu) !== -1)
                ? 'item-name1 active'
                : 'item-name1'
            "
            :style="item.fold ? 'font-weight: 500;' : 'font-weight: 400;'"
            @click="!item.hasChild ? jump(item.path) : toggleFold(idx)"
          >
            <div
              v-if="item.hasChild"
              class="empty-icon"
            ></div>
            {{ item.name }}
            <img
              v-if="item.hasChild && item.fold"
              src="~@/assets/imgs/up.png"
              class="icon"
            />
            <img
              v-if="item.hasChild && !item.fold"
              src="~@/assets/imgs/down.png"
              class="icon"
            />
          </div>
          <template v-if="item.hasChild">
            <div
              v-for="(items, index) in item.menu"
              v-show="item.fold"
              :key="index"
            >
              <div
                dt-eid="tab_link"
                :class="items.fullPath === curMenu ? 'item-name active' : 'item-name'"
                @click="
                  items.path.indexOf('https://') === -1
                    ? jump(items.fullPath ? items.fullPath : '')
                    : headleLink(items.path)
                "
              >
                <span>{{ items.name }}</span>
              </div>
            </div>
          </template>
        </div>
        <div
          v-if="isHideLangAction"
          class="version-header-lang"
        >
          <template
            v-for="(item, key) in langMenu"
            :key="key"
          >
            <span
              :class="{ active: lang === key }"
              :dt-params="`lang=${key}`"
              dt-eid="language_bt"
              @click="handleChangeLang(key)"
              >{{ item }}</span
            >
            <span
              v-if="key === 'zh-CN'"
              :key="`line${key}`"
              :class="['slash-line', 'font48']"
              >/</span
            >
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ViewListIcon } from 'tdesign-icons-vue-next';
import { ABOUT_BAR, INFOMATION_BAR, ABOUT_BAR_EN } from '@/utils/routerConstant';
import { useRoute, useRouter } from 'vue-router';
import { computed, ref, reactive, watch } from 'vue';
import { i18n, translateLang } from '@/utils/lang';
// 导入 useI18n
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['menuStatus']);

// 在 setup 中获取响应式的 t 函数
const { t } = useI18n();

const route = useRoute();
const router = useRouter();

const curMenu = ref('');
const visible = ref(false);

const langMenu = reactive({ 'zh-CN': '中', 'en-US': 'EN' });
const isCN = computed(() => i18n.global.locale.value === 'zh-CN');

// const that = getCurrentInstance().appContext.config.globalProperties;

// 监听路由变化将menuOriginCN和menuOriginEN的fold属性置为false
watch(
  () => route.path,
  (newPath) => {
    // eslint-disable-next-line no-return-assign
    menuOriginCN.forEach((item) => (item.fold = false));
    // eslint-disable-next-line no-return-assign
    menuOriginEN.forEach((item) => (item.fold = false));
  },
);

const menuOriginCN = reactive([
  {
    nameKey: 'menuListCommonwealProject',
    menu: [
      { name: '新基石研究员项目', nameKey: 'newStoneNameNav', path: '', fullPath: '/newcornerstone' },
      { name: '科学探索奖', nameKey: 'scientificNameNav', path: '', fullPath: '/scientific-explorer' },
    ],
    hasChild: true,
    fold: false,
    isEN: true,
  },
  {
    nameKey: 'menuListAcademicExchange',
    menu: [
      { name: '新基石研究员会议', nameKey: 'scientificConference', path: '', fullPath: '/scientific-conference' },
      { name: '新基石50²论坛', nameKey: 'xplorerForum', path: '', fullPath: '/xplorer-forum' },
      { name: '新基石国际研讨会', nameKey: 'scientificSymposiaNav', path: '', fullPath: '/scientific-symposia' },
      { name: '新基石网络研讨会', path: '', fullPath: '/webinar' },
    ],
    hasChild: true,
    fold: false,
    isEN: true,
  },
  {
    name: '新闻资讯',
    path: '/news',
    hasChild: false,
    fold: false,
    isEN: false,
  },
  {
    name: '信息公开',
    menu: INFOMATION_BAR,
    hasChild: true,
    fold: false,
    isEN: false,
  },
  {
    name: '关于我们',
    menu: ABOUT_BAR,
    hasChild: true,
    fold: false,
    isEN: true,
  },
]);
const menuOriginEN = reactive([
  {
    nameKey: 'menuListCommonwealProject',
    menu: [
      {
        name: 'New Cornerstone Investigator Program',
        nameKey: 'newStoneNameNav',
        path: '',
        fullPath: '/newcornerstone',
      },
      { name: 'Xplorer Prize', nameKey: 'scientificNameNav', path: '', fullPath: '/scientific-explorer' },
    ],
    hasChild: true,
    fold: false,
    isEN: true,
  },
  {
    nameKey: 'menuListAcademicExchange',
    menu: [
      {
        name: 'New Cornerstone Investigator Conference',
        nameKey: 'scientificConferenceNav',
        path: '',
        fullPath: '/scientific-conference',
      },
      {
        name: 'New Cornerstone Forum',
        nameKey: 'xplorerForumNav',
        path: '',
        fullPath: '/xplorer-forum',
      },
      {
        name: 'New Cornerstone Symposia',
        nameKey: 'scientificSymposiaNav',
        path: '',
        fullPath: '/scientific-symposia',
      },
    ],
    hasChild: true,
    fold: false,
    isEN: true,
  },
  {
    name: 'About Us',
    menu: ABOUT_BAR_EN,
    hasChild: true,
    fold: false,
    isEN: true,
  },
]);
const menuList = computed(() => {
  const filteredMenu = isCN.value ? menuOriginCN : menuOriginEN;
  return filteredMenu.map((item) => ({
    ...item,
    // 国际化处理
    menu: item.menu
      ? item.menu.map((items) => ({ ...items, name: items.nameKey ? t(items.nameKey) : items.name }))
      : [],
    name: item.nameKey ? t(item.nameKey) : item.name,
  }));
});

const lang = computed(() => i18n.global.locale.value);
watch(
  () => i18n.global.locale,
  (nv) => {
    lang.value = nv;
  },
  { deep: true },
);
const isHideLangAction = computed(() => !route.meta.hideLangAction);

const onIcon = () => {
  if (!visible.value) {
    for (let i = 0; i < menuList.value.length; i++) {
      menuList.value[i].fold = false;
    }
  }
  visible.value = !visible.value;
  emit('menuStatus', visible.value);
};

const headleLink = (url) => {
  window.open(url);
  visible.value = false;
  emit('menuStatus', false);
};

const jump = (path) => {
  console.log(path, '============', router.currentRoute.value);
  if (router.currentRoute.value !== path) {
    router.push(path);
  } else {
    window.location.reload();
  }
  visible.value = false;
  emit('menuStatus', visible.value);
};

const toggleFold = (index) => {
  console.log(index, 'index---toggleFold', isCN.value, menuOriginEN);
  if (isCN.value) {
    menuOriginCN[index].fold = !menuOriginCN[index].fold;
  } else {
    menuOriginEN[index].fold = !menuOriginEN[index].fold;
  }
};

const logo = () => {
  visible.value = false;
  if (router.currentRoute.value === '/') {
    window.location.reload();
    visible.value = false;
    emit('menuStatus', visible.value);
  } else {
    router.push('/');
    visible.value = false;
    emit('menuStatus', visible.value);
  }
};
const handleChangeLang = (lang) => {
  translateLang(lang);
  visible.value = false;
  emit('menuStatus', visible.value);
};
watch(
  () => router.currentRoute.value.path,
  (toPath) => {
    // 要执行的方法
    const path1 = router.currentRoute.value.path;
    curMenu.value = path1;
  },
  { immediate: true, deep: true },
);
</script>
<style lang="scss" scoped>
@mixin nav-text() {
  font-size: 24px;
  font-weight: $bsa-font-weight-regular;
  font-family: $bsa-font-pingfang-sc;
  cursor: pointer;
}
.nav_icon {
  width: 32px;
  height: 32px;
}
.header {
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  box-sizing: border-box;
  position: relative;
  .header-logo {
    width: 164px;
  }
}

.header-center,
.header-right {
  display: flex;
  align-items: center;
}

.header-center {
  flex: 1;
}

.navIcon {
  cursor: pointer;
  display: flex;
}
.modal-show {
  position: absolute;
  top: 80px;
  left: 0;
  right: 0;
  text-align: center;
  background: #fff;
  color: #000000e6;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  line-height: 72px;
  height: calc(100vh - 80px);
  overflow-y: auto;
  .mobile-nav {
    .empty-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
    }
    .icon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
    .item-name {
      background: #f7f7f7ff;
      cursor: pointer;
      line-height: 32px;
      padding: 20px 0;
      -webkit-tap-highlight-color: transparent;
      &.active {
        color: #3278bc;
      }
    }
    .item-name1 {
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      &.active {
        color: #3278bc;
      }
    }
    .active {
      color: #3278bc;
    }
    .slash-line {
      margin: 0 24px;
    }
  }
}
</style>
